import * as types from '@/constants/mutationTypes';

const state = {
  studentsList: []
};
const getters = {
  studentsList: (state) => state.studentsList
};
const actions = {
  setStudentsList ({ commit }, data) {
    commit(types.SET_STUDENTS_LIST, { data });
  }
};
const mutations = {
  [types.SET_STUDENTS_LIST] (state, { data }) {
    state.studentsList = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
